/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_Timecode_DescriptionInputs */

const en_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert timecode settings and options`)
};

const fr_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir les paramètres et options de timecode`)
};

const de_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Einstellungen und -Optionen konvertieren`)
};

const it_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti le impostazioni e le opzioni del timecode`)
};

const ru_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразовать настройки и параметры таймкода`)
};

const es_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir configuraciones y opciones de código de tiempo`)
};

const zh_cn2_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换时间码设置和选项`)
};

const ja_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードの設定とオプションを変換する`)
};

const hi_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड सेटिंग्स और विकल्पों को बदलें`)
};

const pt_pt2_convert_timecode_description = /** @type {(inputs: Convert_Timecode_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter configurações e opções de código de tempo`)
};

/**
* | output |
* | --- |
* | "Convert timecode settings and options" |
*
* @param {Convert_Timecode_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_timecode_description = /** @type {((inputs?: Convert_Timecode_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_Timecode_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_convert_timecode_description(inputs)
	if (locale === "de") return de_convert_timecode_description(inputs)
	if (locale === "it") return it_convert_timecode_description(inputs)
	if (locale === "ru") return ru_convert_timecode_description(inputs)
	if (locale === "es") return es_convert_timecode_description(inputs)
	if (locale === "zh-CN") return zh_cn2_convert_timecode_description(inputs)
	if (locale === "ja") return ja_convert_timecode_description(inputs)
	if (locale === "hi") return hi_convert_timecode_description(inputs)
	if (locale === "pt-PT") return pt_pt2_convert_timecode_description(inputs)
	return en_convert_timecode_description(inputs)
});